<template>
<layout v-if="isReady">
  <div class="row">
    <div class="col-md-6 col-md-offset-3">
      <ul class="list-group">
        <a class="list-group-item"
           v-bind:class="myShop === shop.pk ? 'my-shop' : ''"
           v-for="shop in shopList"
           v-link="reservationsLink(shop)">
          <span class="glyphicon glyphicon-home" aria-hidden="true" v-if="myShop === shop.pk"></span>{{ shop.name }}
        </a>
      </ul>
    </div>
  </div>
</layout>
</template>


<script lang="babel">
import moment from 'moment'
import ShopType from 'ShopType'

export default {
  name: 'index',
  route: {
    data() {
      let requests = [
        this.apiGet('/api/1.0/shops/', {page_size: -1}).then(response => {
          return {'shops': response.body.results}
        }),
      ]

      return Promise.all(requests).then(results => {
        return results.reduce((r1, r2) => Object.assign(r1, r2), {})
      })
    },
  },
  data() {
    return {
      shops: [],
      now: moment(),
    }
  },
  computed: {
    shopList () {
      return this.shops.filter(x => x.shopType === 1)
    },
    isReady() {
      return this.account
    },
    myShop () {
      return this.account._embedded.shop.pk
    },
  },
  methods: {
    reservationsLink(shop, date = moment()) {
      return {
        name: 'reservations',
        params: {
          shopId: shop.pk,
          year: date.format('YYYY'),
          month: date.format('MM'),
          day: date.format('DD'),
        },
      }
    }
  },
  watch: {
    account(val) {
      if (val && val._embedded.shop.shopType == ShopType.SHOP) {
        // this.$router.go(this.reservationsLink(val._embedded.shop))
      }
    },
  },
  mixins: [
    require('mixin/login-required.vue'),
    require('mixin/api-client.vue'),
  ],
  components: {
    layout: require('layout.vue')
  },
}
</script>

<style scoped>
.my-shop {
  background-color: #7FFFD4;
}

</style>



// WEBPACK FOOTER //
// index.vue?5dd40ce4